<template>
  <section class="ren-decoration-cp ren-decoration-cp-scenic-ticket-notice">
    <header class="ren-decoration-cp-scenic-ticket-notice__head">
      <strong>{{ title }}</strong>
    </header>

    <div v-if="showReminder" class="ren-decoration-cp-scenic-ticket-notice__block">
      <div class="ren-decoration-cp-scenic-ticket-notice__subhead">
        <i>订</i>
        <span>预定信息</span>
      </div>
      <p v-for="(line, index) in reminderLines" :key="`reminder-${index}`">{{ line }}</p>
    </div>

    <div v-if="showRules" class="ren-decoration-cp-scenic-ticket-notice__block">
      <div class="ren-decoration-cp-scenic-ticket-notice__subhead">
        <i>规</i>
        <span>使用规则</span>
      </div>
      <p v-for="(line, index) in rulesLines" :key="`rules-${index}`">{{ line }}</p>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const title = computed(() => stringValue(props.component.props?.title, '购买须知'))
const showReminder = computed(() => booleanValue(props.component.props?.showReminder, true))
const showRules = computed(() => booleanValue(props.component.props?.showRules, true))

const reminderLines = computed(() => {
  const value = props.component.props?.reminderLines
  return Array.isArray(value) && value.length
    ? value.map(String)
    : ['请在游玩当日的营业时间内核验使用。', '1.2 米以下儿童免票，需由成人陪同入园。']
})
const rulesLines = computed(() => {
  const value = props.component.props?.rulesLines
  return Array.isArray(value) && value.length
    ? value.map(String)
    : ['未使用门票可在游玩当日 23:59 前申请退款。', '过期未使用自动作废，不支持改期。']
})
</script>

<style scoped>
.ren-decoration-cp-scenic-ticket-notice {
  display: grid;
  gap: 10px;
  padding: 12px;
  background: var(--ren-theme-card);
}
.ren-decoration-cp-scenic-ticket-notice__head strong {
  color: var(--ren-theme-text);
  font-size: 14px;
}
.ren-decoration-cp-scenic-ticket-notice__block {
  display: grid;
  gap: 4px;
}
.ren-decoration-cp-scenic-ticket-notice__subhead {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  color: var(--ren-theme-text);
  font-size: 12px;
  font-weight: 600;
}
.ren-decoration-cp-scenic-ticket-notice__subhead i {
  display: inline-grid;
  place-items: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--ren-theme-border);
  color: var(--ren-theme-muted);
  font-style: normal;
  font-size: 10px;
}
.ren-decoration-cp-scenic-ticket-notice__block p {
  margin: 0;
  color: var(--ren-theme-muted);
  font-size: 12px;
  line-height: 1.6;
}
</style>
